import { useBreakpoint } from '@react-spectrum/utils';
import React from 'react';
import styled from 'styled-components';

// Shared libs
import { HeaderContainer } from '@exchange-frontends/components';

import { FiltersDialogTrigger } from './partials/FiltersDialogTrigger';
import SortElement from './partials/SortElement';

const BrowseHeader = styled(HeaderContainer)`
  &&& {
    justify-content: flex-end;
    padding-right: 20px;
  }
`;

/**
 * BrowseHeader
 * @component
 * @category Browse
 */
const Header = () => {
  const { matchedBreakpoints } = useBreakpoint();
  const isTabletSize = !matchedBreakpoints.includes('L');

  return isTabletSize ? (
    <BrowseHeader>
      <SortElement mobileVersion />
      <FiltersDialogTrigger />
    </BrowseHeader>
  ) : null;
};

export default Header;
